import './Button.scss';
import React from 'react';
import classNames from 'classnames';
import Tooltip from '@/components/basic/Tooltip/Tooltip';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';

export type ButtonProps = Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    'type' | 'onClick'
> & {
    variant?: ButtonVariant;
    htmlType?: 'button' | 'submit' | 'reset';
    tooltip?: string;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            children,
            variant = 'primary',
            className,
            tooltip,
            disabled,
            htmlType = 'button',
            onClick,
            ...props
        },
        ref,
    ) => {
        const renderButton = (() => {
            return (
                <button
                    ref={ref}
                    type={htmlType}
                    className={classNames(
                        'Button',
                        `Button-${variant}`,
                        className,
                    )}
                    disabled={disabled}
                    onClick={(e) => {
                        onClick?.(e);
                    }}
                    {...props}
                >
                    {children}
                </button>
            );
        })();

        if (tooltip) {
            return <Tooltip content={tooltip}>{renderButton}</Tooltip>;
        }

        return renderButton;
    },
);

Button.displayName = 'Button';

export default Button;
